import Accordion from '../components/accordion';

export default class Example {
    constructor (query) {
        const el = document.querySelector(query);
        if (!el) return;

        this.el = el;

        this.init();
    }

    init () {
        const accordion = this.el.querySelector('.site-accordion[data-accordion=accordion]');
        if (!accordion) return;

        new Accordion('.site-accordion[data-accordion=accordion]', {
            default: 0,
            onChange: (index) => console.log(`Accordion item changed: ${index}`)
        }); 
    }
}
